// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ulQOk","controls":"styles_controls__3la0L","charLimit":"styles_charLimit__swECX","input":"styles_input__10Rt8","send":"styles_send__2Nm9B"};